export default {
  heading: {
    subtitle: "Changement de chauffe-eau à Toulouse",
    icons: [
      {
        src: "/img/icons/approve-invoic-bicolor-light.png",
        alt: "Icone devis",
      },
      {
        src: "/img/icons/calendar-bicolor-light.png",
        alt: "Icone calendrier",
      },
      {
        src: "/img/icons/piggy-bank-bicolor-light.png",
        alt: "Icone tarifs",
      },
    ],
    items: [
      " Déplacement devis gratuit",
      " Intervention dans la semaine",
      " Installation à partir de 270 € TTC",
    ],
  },
  section1: {
    title: "Optez pour la tranquillité :",
    text: `Pour la <span class="bold">sécurité </span>
      comme pour le
      <span class="bold"> bon fonctionnement</span>, il est
      important qu’un changement de chauffe-eau soit fait convenablement.
      <br />
      Afin de vous garantir la meilleure qualité de service, tous nos
      plombiers-chauffagistes sont engagés en CDI et ont au moins 7 ans
      d'expérience dans le métier.`,
    ctaText: "Pour un devis gratuit, appelez-nous au :",
  },
  section2: {
    title: "",
    subtitle1: "",
    steps1: [
      "S’assurer que l’installation électrique respecte les normes NF",
      "Déposer l’ancien chauffe-eau",
      "Préparer le nouveau chauffe-eau pour la pose, y installer un groupe de sécurité puis le fixer en laissant un espace suffisant pour son entretien",
      "Raccorder au circuit d’eau",
      "Mettre en service le nouveau chauffe-eau",
    ],
    text1: "",
    subtitle2: "",
    text2:
      "Selon l’accessibilité et le taille de l’équipement, un changement de chauffe-eau peut durer de 2 à 4h.",
    subtitle3: "",
    text3: "Un devis de changement de chauffe-eau comprend 3 lignes :",
    steps3: [
      "Le coût du nouveau chauffe-eau (prix variable selon type, marque et volume)",
      "La main d’oeuvre, compter 60 € TTC l’heure soit 120 à 240 € pour la durée totale",
      "La fourniture pour la fixation du chauffe-eau et les raccords (fonction du modèle et de la disposition)",
    ],
    lastText: "↠ Au total, le tarif peut varier de 270 € à plus de 900 € TTC",
    ctaText: "Planifiez votre RDV dans la semaine ! <br />",
    ctaTextMobile:
      'Appelez-nous et planifiez <br />votre entretien dans <span class="no-wrap"> la semaine !</span>',
  },
  aside: {
    ctaText: "Un chauffe-eau à réparer ou à changer ? Appelez-nous : ",
    img: {
      src: "/img/pages/mix-chauffe-eau.jpg",
      alt: "Changement de chauffe-eau",
    },
    quoteRequest: {
      recipient: "contact+devischauffe-eau",
      body:
        "Bonjour,%0D%0A %0D%0A voici ma demande de devis de changement de chauffe-eau :%0D%0A - Description : %0D%0A - Délai : %0D%0A - Code postal : %0D%0A - Ville : %0D%0A - Nom : %0D%0A - Numéro de téléphone (optionnel) : %0D%0A %0D%0A Bien à vous",
    },
  },
};
